import { createSlice } from '@reduxjs/toolkit';
import {
  calculateRatingSummary,
  fetchProductRatings,
  postProductRating,
} from '../thunk/product-rating';

// Slice
const reviewsSlice = createSlice({
  name: 'ratings',
  initialState: {
    items: [],
    pagination: {
      total: 0,
      current_page: 1,
      per_page: 10,
      next: null,
    },
    ratingSummary: {
      average: 0,
      totalRatings: 0,
      distribution: {
        5: 0,
        4: 0,
        3: 0,
        2: 0,
        1: 0,
      },
    },
    status: 'idle', // idle | loading | succeeded | failed
    postStatus: 'idle', // idle | loading | succeeded | failed
    error: null,
    isRatingOpen: false,
  },
  reducers: {
    resetRatingPostStatus: (state) => {
      state.postStatus = 'idle';
      state.error = null;
    },
    setReviews: (state, action) => {
      state.items = action.payload.items || [];
      state.pagination = action.payload.pagination || {
        total: 0,
        current_page: 1,
        per_page: 10,
        next: null,
      };
      calculateRatingSummary(state);
    },
    setIsRatingOpen: (state, action) => {
      state.isRatingOpen = action.payload;
    },
    updateReview: (state, action) => {
      const { index, review } = action.payload;
      if (state.items[index]) {
        state.items[index] = { ...state.items[index], ...review };
        calculateRatingSummary(state);
      }
    },
    resetReviews: (state) => {
      state.items = [];
      state.pagination = {
        total: 0,
        current_page: 1,
        per_page: 10,
        next: null,
      };
      state.ratingSummary = {
        average: 0,
        totalRatings: 0,
        distribution: {
          5: 0,
          4: 0,
          3: 0,
          2: 0,
          1: 0,
        },
      };
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch product ratings
      .addCase(fetchProductRatings.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProductRatings.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items || [];
        state.pagination = action.payload.pagination || {
          total: 0,
          current_page: 1,
          per_page: 10,
          next: null,
        };
        calculateRatingSummary(state);
      })
      .addCase(fetchProductRatings.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch product ratings.';
      })

      // Post product rating
      .addCase(postProductRating.pending, (state) => {
        state.postStatus = 'loading';
        state.error = null;
      })
      .addCase(postProductRating.fulfilled, (state) => {
        state.postStatus = 'succeeded';
        state.error = null;
        // state.items.push(action.payload);
        // calculateRatingSummary(state);
      })
      .addCase(postProductRating.rejected, (state, action) => {
        state.postStatus = 'failed';
        state.error =
          action?.payload?.message || 'Failed to post product rating.';
      });
  },
});

// Export actions and reducer
export const {
  setReviews,
  updateReview,
  resetReviews,
  resetRatingPostStatus,
  setIsRatingOpen,
} = reviewsSlice.actions;

export default reviewsSlice.reducer;
